export const greetingFields = ['GreetingText', 'GreetingFont', 'GreetingSize', 'GreetingColor', 'GreetingImageID', 'GreetingLogoID'];

export function greetingValues(order) {
    const imageId = Number(order?.GreetingImageID);
    if (Number.isInteger(imageId) && imageId > 0) return JSON.stringify(['image', String(imageId)]);
    return JSON.stringify(greetingFields.map((key) => (key === 'GreetingImageID' ? '' : String(order?.[key] ?? ''))));
}

export async function approvalChangeDecision(vm, state, changed) {
    if (!changed || !state.approved) return {};
    if (state.versions?.[state.approved]?.source === 'manual_image') return {};
    const result = await vm.$swal({
        title: 'Ska godkänt korr tas bort från order?',
        text: 'Filerna behålls i historiken. Ja återkallar godkännandet. Nej behåller godkänt underlag för tryck.',
        icon: 'question',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'Ja, återkalla',
        denyButtonText: 'Nej, behåll',
        cancelButtonText: 'Avbryt',
    });
    if (!result.isConfirmed && !result.isDenied) {
        const error = new Error('Sparandet avbröts.'); error.cancelled = true; throw error;
    }
    return { approval_decision: result.isConfirmed, archive_revision: state.revision };
}
